import * as Sentry from "@sentry/react";
import { compose, withHandlers } from "recompose";
import { Loader, LoaderError, withLoader } from "@dpdgroupuk/mydpd-ui";
import { withFeedback } from "@dpdgroupuk/react-sentry-feedback";
import { connect } from "react-redux";
import { clearAppUserData } from "../features/App/AppActions";
import { withAppContext } from "../Context";
export const loaderHOC = compose(withFeedback, withAppContext, connect(null, (dispatch, {
  app
}) => ({
  onGoToLoginClick: async () => {
    dispatch(clearAppUserData());
    await app.auth.logout();
  }
})), withHandlers({
  onReportFeedbackClick: ({
    feedback,
    onGoToLoginClick
  }) => eventId => feedback.showReportDialog({
    eventId,
    onClose: onGoToLoginClick
  }),
  onLoadFailure: () => error => {
    if (error.statusCode && error.statusCode >= 500) {
      return Sentry.captureException(error);
    }

    throw new LoaderError(error);
  }
}));
export const AppLoader = loaderHOC(Loader);
export const withAppLoader = params => compose(loaderHOC, withLoader(params));